import classNames from "classnames/dedupe";
import React from "react";

import cls from "./Card.less";

export const Card = (props: { children: JSX.Element[] | JSX.Element; className?: string; baseStyle?: boolean }) => (
  <div className={classNames(cls.card, !props.baseStyle && cls.cardContent, props.className)}>{props.children}</div>
);
